import { Injectable, inject } from '@angular/core';
import { BaseComponent } from '@wms/app/components';
import { FileService, ProjectService } from '@wms/services'

@Injectable({
  providedIn: 'root'
})
export class CustomExtensionService extends BaseComponent {

  fileService: FileService
  constructor() {
    super();
    this.fileService = inject(FileService);
  }

  // Append the formatter script to document head
  appendFormattersScriptDocument(url: any) {
    return new Promise<void>((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = "foramtterjs"
      script.onload = () => {
        let windowObj: any = window;
        let formatterobj: any = windowObj['WM_CUSTOM_FORMATTERS']
        if (!formatterobj) {
          console.warn('Formatters file should return the valid formatters object');
          resolve();
        }
        resolve(formatterobj);
      }

      //Error handling while loading the script
      script.onerror = (error: any) => {
        //console.warn('Error loading ' + this.src);
        console.warn(error);
      }
      let scriptnode = document.getElementById('foramtterjs');
      if (scriptnode) {
        scriptnode.remove();
      }
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }


  getAppExtensionUrl() {
    return new Promise((res, rej) => {
      let relativePath = '/src/main/webapp/extensions/formatters.js',
        resourcePath = '../project' + relativePath;

      let fileConfig: any;
      (this.fileService.getFileConfig({
        urlParams: {
          projectID: this.projectService.getProjectId(),
          filePath: resourcePath
        }
      }) as Promise<any>).then((response: any) => {
        fileConfig = response;
        res(fileConfig.url);
      });
    });

  }


  // Load the formatters file and return the custom pipes
  getCustomFormatters() {
    return new Promise<void>((resolve, reject) => {
      if (this.projectService.isPrefabType() || this.projectService.isTemplateBundleType()) {
        return resolve();
      }
      return this.getAppExtensionUrl().then((url) => {
        return resolve(this.appendFormattersScriptDocument(url));
      });
    });
  }
}
